// 月日の短い表示 (「10/25」。左ペインのお客様の行の右端)。back の日付 (YYYY-MM-DD = 店舗の日) をそのまま読む
// (formatYmd と同じく Date に通さない)。
export const formatMd = (ymd: string): string => {
  const [, m, d] = ymd.slice(0, 10).split('-').map(Number)
  return `${m}/${d}`
}

// 年月日 (「2026/10/8」)。back の日付 (YYYY-MM-DD = 店舗の日) をそのまま読む: 報告書の格子の実施日・前回の
// 報告書の見出し・回の字。Date に通さない (new Date('YYYY-MM-DD') は UTC の 0 時で、
// 端末の時差で前日に落ちる)。
export const formatYmd = (ymd: string): string => {
  const [y, m, d] = ymd.slice(0, 10).split('-').map(Number)
  return `${y}/${m}/${d}`
}
